import {
  getGeoJsonPropertyNumber,
  getGeoJsonPropertyText,
  setGeoJsonProperty,
} from 'shared/map/domain/geojson';
import { ShapeMode } from 'shared/shapes/domain/shapeMode';

const storageAreaIdKey = 'storageAreaId';

export function getStorageAreaId(feature: GeoJSON.Feature) {
  return getGeoJsonPropertyText(feature, storageAreaIdKey);
}

export function setStorageAreaId(feature: GeoJSON.Feature, storageAreaId: string) {
  setGeoJsonProperty(feature, storageAreaIdKey, storageAreaId);
}

const shapeIdKey = 'shapeId';

export function getShapeId(feature: GeoJSON.Feature) {
  return getGeoJsonPropertyText(feature, shapeIdKey);
}

export function setShapeId(feature: GeoJSON.Feature, shapeId: string) {
  return setGeoJsonProperty(feature, shapeIdKey, shapeId);
}

const modeKey = 'mode';

export function getMode(feature: GeoJSON.Feature) {
  const text = getGeoJsonPropertyText(feature, modeKey);
  switch (text) {
    case 'polygon':
      return ShapeMode.Polygon;
  }

  return ShapeMode.Rectangle;
}

export function setMode(feature: GeoJSON.Feature, mode: ShapeMode) {
  let value = 'rectangle';

  switch (mode) {
    case ShapeMode.Polygon:
      value = 'polygon';
  }

  setGeoJsonProperty(feature, modeKey, value);
}

export interface ShapeGeoJson {
  shape: GeoJSON.Feature;
  geofence: GeoJSON.Feature;
}
